import { CS } from "../../../../../base/utils/styler";

export const baseStyle: CS = {
}

export const titleStyle: CS = {
    paddingTop: '5px',
    fontSize: '18px',
}

export const listStyle: CS = {
    height: 'calc(100vh - 200px)',
    overflow: 'auto',
    paddingBottom: '100px'
}

export const addNewArticleStyle: CS = {
    cursor: 'pointer',
    padding: '5px',
    border: '1px solid #d9d9d9',
    borderRadius: '5px',
    width: 'fit-content',
    margin: '10px 0',
    color: 'gray',
    '&:hover': {
        color: 'black'
    }
}